import LoaderIcon from '../../assets/icons/loader-icon.svg'

const SmallLoader = () => {
	return (
		<img src={LoaderIcon} alt="loader icon" className="w-[20px] h-[20px] rounded-full animate-spin" />
	)
}

export default SmallLoader